const footballRoute = [
  {
    path: '/database/statusbarheight/:statusbarheight/sport/1/league/:leagueId', // football联赛
    component: () => import('@/views/football/league/menulayout'),
    children: [
      {
        path: 'schedule',
        name: 'football-league-schedule',
        component: () => import('@/views/football/league/schedule')
      },
      {
        path: 'standings', // 积分榜
        name: 'football-league-standings',
        component: () => import('@/views/football/league/standings')
      },
      {
        path: 'players', // 球员榜
        name: 'football-league-players',
        component: () => import('@/views/football/league/players')
      },
      {
        path: 'odds-statistics', // 盘路统计
        name: 'football-league-odds-statistics',
        component: () => import('@/views/football/league/oddsStatistics')
      }
    ]
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/1/team/:teamId', // football球队
    component: () => import('@/views/football/team/team-menu'),
    props: true,
    children: [
      {
        path: 'fixture',
        name: 'football-team-schedule',
        props: true,
        component: () => import('@/views/football/team/schedule')
      },
      {
        path: 'previous', // 往绩
        name: 'football-team-previous',
        component: () => import('@/views/football/team/previous')
      },
      {
        path: 'stats', // 数据
        name: 'football-team-stats',
        props: true,
        component: () => import('@/views/football/team/stats')
      },
      {
        path: 'line-up', // 阵容
        name: 'football-team-line-up',
        props: true,
        component: () => import('@/views/football/team/line-up')
      },
      {
        path: 'player-list',
        name: 'football-team-player-list',
        props: true,
        component: () => import('@/views/football/team/player-list')
      },
      {
        path: 'info', // 资料
        name: 'football-team-info',
        component: () => import('@/views/football/team/info')
      },
      {
        path: 'transfer', // 转会
        name: 'football-team-transfer',
        props: true,
        component: () => import('@/views/football/team/transfer')
      }
    ]
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/1/coach/:teamId', // football教练
    name: 'football-coach',
    props: true,
    component: () => import('@/views/football/team/coach')
  },
  {
    path: '/database/statusbarheight/:statusbarheight/sport/1/player/:playerId', // football球员,
    component: () => import('@/views/football/player'),
    props: true,
    children: [
      {
        path: 'info',
        name: 'football-player-info',
        props: true,
        component: () => import('@/views/football/player/info')
      },
      {
        path: 'stats',
        name: 'football-player-stats',
        props: true,
        component: () => import('@/views/football/player/stats')
      }
    ]
  }
]

export default footballRoute
